"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __importDefault(require("firebase/app"));
var auth_service_1 = __importDefault(require("./auth.service"));
var MediaService = (function () {
    function MediaService() {
    }
    MediaService.prototype.getMediaForComic = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, poster, thumbnail, title;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, Promise.all([
                            this.getImageUrl("comics/".concat(id, "/poster.jpg")),
                            this.getImageUrl("comics/".concat(id, "/thumbnail.jpg")),
                            this.getImageUrl("comics/".concat(id, "/title.png"))
                        ])];
                    case 1:
                        _a = _b.sent(), poster = _a[0], thumbnail = _a[1], title = _a[2];
                        return [2, {
                                poster: poster,
                                thumbnail: thumbnail,
                                title: title,
                            }];
                }
            });
        });
    };
    MediaService.prototype.getEpisodeListWithThumbnails = function (comicId, episodeList) {
        return __awaiter(this, void 0, void 0, function () {
            var thumbnails;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, Promise.all(episodeList.map(function (_a) {
                            var episodeId = _a.id;
                            return Promise.all([
                                _this.getImageUrl("comics/".concat(comicId, "/").concat(episodeId, "/cover_thumb.jpg")),
                                _this.getImageUrl("comics/".concat(comicId, "/").concat(episodeId, "/thumbnail.jpg")),
                            ]);
                        }))];
                    case 1:
                        thumbnails = _a.sent();
                        return [2, episodeList.map(function (episode, inx) { return (__assign(__assign({}, episode), { media: __assign(__assign({}, (episode.media || {})), { coverThumb: thumbnails[inx][0], thumbnail: thumbnails[inx][1] }) })); })];
                }
            });
        });
    };
    MediaService.prototype.getPagesForEpisode = function (comicId, episode, lang) {
        return __awaiter(this, void 0, void 0, function () {
            var pageIds, defLang, i;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pageIds = [];
                        defLang = episode.supportedLangs.includes(lang) ? lang : episode.supportedLangs[0];
                        for (i = 1; i <= episode.pageCount; i++)
                            pageIds.push('P' + (('00' + i).slice(-2)) + '.jpg');
                        return [4, Promise.all(pageIds.map(function (pageId) { return _this.getImageUrl("comics/".concat(comicId, "/").concat(episode.id, "/").concat(defLang, "/").concat(pageId)); }))];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    MediaService.prototype.getImageUrl = function (path) {
        return __awaiter(this, void 0, void 0, function () {
            var ref, meta, err_1, bucket;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!auth_service_1.default.isSignedInAsAdmin()) return [3, 7];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        ref = app_1.default.storage().ref(path);
                        return [4, ref.getMetadata()];
                    case 2:
                        meta = _a.sent();
                        if (!!meta.cacheControl) return [3, 4];
                        console.log(">>> logged as admin and updating metadata for: \"".concat(path, "\""));
                        return [4, ref.updateMetadata({ cacheControl: 'public, max-age=7200' })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2, ref.getDownloadURL()];
                    case 5:
                        err_1 = _a.sent();
                        return [2, ''];
                    case 6: return [3, 8];
                    case 7:
                        bucket = 'comixtopia-2021.appspot.com';
                        return [2, "https://firebasestorage.googleapis.com/v0/b/".concat(bucket, "/o/").concat(encodeURIComponent(path), "?alt=media")];
                    case 8: return [2];
                }
            });
        });
    };
    return MediaService;
}());
exports.default = new MediaService();
